import React, { useState, useEffect, useCallback } from "react";

import { TabProps } from "./types";

export const Tab: React.FC<TabProps> = ({
  options,
  initialActiveIndex = 0,
  className = "",
  tabListClassName = "",
  tabItemClassName = "",
  activeTabItemClassName = "",
  tabContentClassName = "",
  onChange,
}) => {
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);

  useEffect(() => {
    // Ensure the initialActiveIndex is within the bounds of the options array
    if (
      options.length > 0 &&
      (initialActiveIndex < 0 || initialActiveIndex >= options.length)
    ) {
      console.warn(
        "initialActiveIndex is out of bounds. Defaulting to the first tab."
      );
      setActiveIndex(0);
    }
  }, [options.length, initialActiveIndex]);

  const handleTabClick = useCallback((index: number) => {
    setActiveIndex(index);
    onChange?.(index);
  }, [onChange]);

  if (!options || options.length === 0) {
    return <div>No tabs available.</div>;
  }

  return (
    <div className={`tab-component ${className}`}>
      <ul className={`tab-list ${tabListClassName}`} role="tablist">
        {options.map((option, index) => (
          <button
            key={index}
            className={`tab-item ${tabItemClassName} ${
              index === activeIndex ? activeTabItemClassName : ""
            }`}
            role="tab"
            aria-selected={index === activeIndex}
            aria-controls={`tab-panel-${index}`}
            id={`tab-${index}`}
            onClick={() => handleTabClick(index)}
          >
            {option.label}
          </button>
        ))}
      </ul>

      <div className={`tab-content ${tabContentClassName}`}>
        {options.map((option, index) => (
          <div
            key={index}
            id={`tab-panel-${index}`}
            className={`${index === activeIndex ? "active" : "hidden"}`}
            role="tabpanel"
            aria-labelledby={`tab-${index}`}
          >
            {option.content}
          </div>
        ))}
      </div>
    </div>
  );
};
